{
  "familyId": "GET-KOMMA-MIN",
  "questions": [
    {
      "id": "GET-KOMMA-MIN-001",
      "familyId": "GET-KOMMA-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is 5,3 − 2,7?",
      "options": [
        "2,6",
        "3,4",
        "2,4",
        "3,6"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen aftrekken — lenen",
            "content": "Als je niet kunt aftrekken (3 tienden − 7 tienden kan niet), leen je 1 van de eenheden. Die 1 wordt 10 tienden. Dan: 13 − 7 = 6 tienden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_aftrekken_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Kijk naar de tienden: 3 − 7 kan niet. Leen 1 van de eenheden: de 5 wordt 4, en de 3 tienden worden 13 tienden. Nu: 13 − 7 = 6 tienden. Eenheden: 4 − 2 = 2. Antwoord: 2,6. Controleer: 2,6 + 2,7 = 5,3 ✓.",
        "distractorExplanations": {
          "0": "Goed! 5,3 − 2,7 = 2,6. Je moet lenen bij de eenheden omdat 3 tienden − 7 tienden niet kan.",
          "1": "Je dacht waarschijnlijk dat je de tienden mocht omdraaien (7 − 3 = 4). Maar je trekt 2,7 af van 5,3, niet andersom. Leen 1 van de eenheden: 13 − 7 = 6. Onthoud: je mag de volgorde niet omdraaien bij aftrekken.",
          "2": "Je dacht waarschijnlijk dat de eenheid na het lenen 5 blijft. Maar na het lenen wordt de 5 een 4: 4 − 2 = 2. Onthoud: als je leent, wordt het getal dat je van leent één kleiner.",
          "3": "Je dacht waarschijnlijk dat je de tienden mocht omdraaien of verkeerd leende. Leen 1 van de eenheden: 13 − 7 = 6 en 4 − 2 = 2. Antwoord: 2,6. Onthoud: controleer altijd door op te tellen: 2,6 + 2,7 = 5,3."
        }
      }
    },
    {
      "id": "GET-KOMMA-MIN-002",
      "familyId": "GET-KOMMA-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is 10 − 3,45?",
      "options": [
        "6,55",
        "7,55",
        "6,65",
        "7,45"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Heel getal aftrekken — schrijf nullen",
            "content": "Schrijf 10 als 10,00 zodat je de komma's recht onder elkaar kunt zetten. Dan trek je stap voor stap af met lenen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_aftrekken_heel_getal",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Schrijf 10 als 10,00. Nu: 10,00 − 3,45. Honderdsten: 0 − 5 kan niet → leen: 10 − 5 = 5. Tienden: 9 − 4 = 5 (de 0 werd 9 door lenen). Eenheden: 9 − 3 = 6 (de 10 werd 9 door lenen). Antwoord: 6,55. Controleer: 6,55 + 3,45 = 10 ✓.",
        "distractorExplanations": {
          "0": "Goed! 10,00 − 3,45 = 6,55. Let op het dubbel lenen.",
          "1": "Je dacht waarschijnlijk dat de eenheid na het lenen bij de tienden nog 10 is. Maar na het lenen wordt de 10 op de eenhedenplek 9: 9 − 3 = 6, niet 7. Onthoud: elke lening maakt het getal één kleiner.",
          "2": "Je dacht waarschijnlijk dat de tiendenplek na het lenen 10 wordt. Maar na het lenen bij de honderdsten wordt de 0 op de tiendenplek 9 (niet 10): 9 − 4 = 5, niet 6. Onthoud: je leent 1, dus de plek wordt 9 + 1 = 10 → schrijf 9 na het lenen.",
          "3": "Je dacht waarschijnlijk dat je alleen de eenheden hoeft af te trekken. Maar 10 − 3,45 betekent ook de decimalen aftrekken: 10,00 − 3,45 = 6,55, niet 7,45. Onthoud: schrijf 10 als 10,00 en trek alles af."
        }
      }
    },
    {
      "id": "GET-KOMMA-MIN-003",
      "familyId": "GET-KOMMA-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een fles bevat 1,5 liter. Je schenkt 0,75 liter in. Hoeveel zit er nog in de fles?",
      "options": [
        "0,75 liter",
        "0,85 liter",
        "1,25 liter",
        "2,25 liter"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen aftrekken met ongelijk aantal decimalen",
            "content": "Maak het aantal decimalen gelijk door nullen toe te voegen: 1,5 = 1,50. Zet de komma's recht onder elkaar en trek stap voor stap af.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_aftrekken_context",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Schrijf 1,5 als 1,50. Nu: 1,50 − 0,75. Honderdsten: 0 − 5 → leen: 10 − 5 = 5. Tienden: 4 − 7 → leen: 14 − 7 = 7. Eenheden: 0 − 0 = 0. Antwoord: 0,75 liter. Controleer: 0,75 + 0,75 = 1,50 ✓.",
        "distractorExplanations": {
          "0": "Goed! 1,50 − 0,75 = 0,75 liter. Precies de helft is overgebleven.",
          "1": "Je dacht waarschijnlijk dat je het lenen verkeerd verwerkt hebt. Controleer stap voor stap: 1,50 − 0,75 = 0,75, niet 0,85. Onthoud: controleer door op te tellen: 0,75 + 0,75 = 1,50.",
          "2": "Je dacht waarschijnlijk dat je alleen de tienden hoeft af te trekken. Maar je trekt 0,75 af, niet 0,25. 1,50 − 0,25 = 1,25, maar 1,50 − 0,75 = 0,75. Onthoud: kijk goed naar het volledige getal dat je aftrekt.",
          "3": "Je dacht waarschijnlijk dat je moest optellen. Maar je schenkt in — dat is aftrekken. 1,5 − 0,75 = 0,75, niet 1,5 + 0,75 = 2,25. Onthoud: inschenken = weghalen = aftrekken."
        }
      }
    },
    {
      "id": "GET-KOMMA-MIN-004",
      "familyId": "GET-KOMMA-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is 8,04 − 2,6?",
      "options": [
        "5,44",
        "5,98",
        "6,44",
        "5,4"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nul op de tiendenplek",
            "content": "In 8,04 staat een 0 op de tiendenplek. Maak het aantal decimalen gelijk: 2,6 = 2,60. Dan: 8,04 − 2,60. Let op: 0 tienden − 6 tienden kan niet → leen van de eenheden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_aftrekken_nul",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Maak het aantal decimalen gelijk: 2,6 = 2,60. Nu: 8,04 − 2,60. Honderdsten: 4 − 0 = 4. Tienden: 0 − 6 kan niet → leen: 10 − 6 = 4. Eenheden: 7 − 2 = 5 (de 8 werd 7 door lenen). Antwoord: 5,44. Controleer: 5,44 + 2,60 = 8,04 ✓.",
        "distractorExplanations": {
          "0": "Goed! 8,04 − 2,60 = 5,44.",
          "1": "Je dacht waarschijnlijk dat 2,6 hetzelfde is als 2,06. Maar 2,6 = 2,60 (zes tienden), niet 2,06 (zes honderdsten). 8,04 − 2,06 = 5,98, maar dat is niet wat gevraagd wordt. Onthoud: 2,6 = 2,60, voeg een nul toe achteraan.",
          "2": "Je dacht waarschijnlijk dat de eenheid na het lenen 8 blijft. Maar na het lenen bij de tienden wordt de 8 een 7: 7 − 2 = 5, niet 6. Onthoud: elke lening maakt het getal één kleiner.",
          "3": "Je dacht waarschijnlijk dat het antwoord maar één decimaal heeft. Maar 8,04 heeft twee decimalen, dus het antwoord ook: 5,44, niet 5,4. Onthoud: het aantal decimalen in het antwoord is gelijk aan het grootste aantal decimalen in de opgave."
        }
      }
    },
    {
      "id": "GET-KOMMA-MIN-005",
      "familyId": "GET-KOMMA-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_aftrekken",
      "questionType": "multiple_choice",
      "question": "Wat is 20 − 0,01?",
      "options": [
        "19,99",
        "19,09",
        "19,9",
        "20,01"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Klein kommagetal aftrekken van groot getal",
            "content": "Schrijf 20 als 20,00. Dan: 20,00 − 0,01. Leen stap voor stap: honderdsten → tienden → eenheden. Elke lening maakt het getal één kleiner.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_aftrekken_klein_verschil",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Schrijf 20 als 20,00. Nu: 20,00 − 0,01. Honderdsten: 0 − 1 → leen: 10 − 1 = 9. Tienden: 9 − 0 = 9 (de 0 werd 9 door lenen). Eenheden: 9 − 0 = 9 (de 20 werd 19 door lenen). Antwoord: 19,99. Controleer: 19,99 + 0,01 = 20 ✓.",
        "distractorExplanations": {
          "0": "Goed! 20,00 − 0,01 = 19,99. Eén honderdste minder dan 20.",
          "1": "Je dacht waarschijnlijk dat de lening niet doorloopt naar alle posities. Maar elke lening beïnvloedt de volgende positie. 20,00 − 0,01 = 19,99, niet 19,09. Onthoud: controleer door op te tellen: 19,99 + 0,01 = 20.",
          "2": "Je dacht waarschijnlijk dat het antwoord maar één decimaal heeft. Maar 0,01 heeft twee decimalen, dus het antwoord ook: 19,99, niet 19,9. Onthoud: schrijf altijd het juiste aantal decimalen.",
          "3": "Je dacht waarschijnlijk dat je moest optellen. Maar de vraag is 20 − 0,01 = 19,99, niet 20 + 0,01 = 20,01. Onthoud: het minteken betekent aftrekken — het antwoord is kleiner dan 20."
        }
      }
    }
  ]
}